import { createClient } from "@supabase/supabase-js";

const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_ANON_KEY,
  {
    auth: {
      // Disable the Web Locks API used to serialize auth token storage.
      // The lock can get stuck in a bad state on some browsers, causing all
      // subsequent Supabase calls to hang indefinitely. For a single-user
      // family app this coordination is unnecessary.
      lock: (_name, _acquireTimeout, fn) => fn(),
    },
  }
);

export default supabase;
